import React, { useEffect } from 'react'
import "./Latest_Audio.css";
import Common_Title_3 from "../../common/common_components/Common_Title_3/Common_Title_3";
import Latest_Card from "../../common/common_components/latest_card/Latest_Card";
import { useDispatch, useSelector } from 'react-redux';
import { AllChants, AllChantsAlbum } from '../../../features/admin/common/Slice';
import { IDS } from '../../../utils/IDS';
import Pravachan_Card from '../gurujis_pravachan/pravachan_card/Pravachan_Card';

const Latest_Audio = () => {

  const dispatch = useDispatch();
  const chantsAl = useSelector((state) => state.common.all_chants);


  useEffect(() => {
    dispatch(AllChants());
  }, [dispatch]);

  return (
    <section className='Latest_Audio'>
      <div className="container">
        <Common_Title_3 titleText="Latest Audio" seelink={'/all-latest-audio'} />

        <div className="row">
          {chantsAl?.slice(0, 4)?.map((chant, index) => {
            return (
              <div className="col-lg-3 col-md-4 col-sm-6 mb-4">
                <Pravachan_Card
                  image={chant?.image}
                  name={chant?.name}
                  album={chant?.Chant_Type?.name}
                  music={chant}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  )
}

export default Latest_Audio
